<div class="phone" [class.error]="showError">
	<span>{{ phoneCode }}</span>
	<input
		#input type="text"
		[value]="value"
		[maxLength]="maxLength"
		(input)="inputValidator($event)"
		placeholder="{{ placeholder }}"
		[attr.disabled]="disabled">
</div>
